import React from 'react';

export default function EventFlagIcon({
    color,
    size,
    width = size || "1em",
    height = size || "1em",
    className = "",
    style = {},
    ...rest
} = {}) {
    const iconColor = color || "currentColor";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
            {...rest}
        >
            <path
                d="M8.43457 19.3068C8.19157 19.3068 7.96657 19.1538 7.87657 18.9198L5.33857 12.1338L3.07957 5.94179C2.94457 5.56379 2.96257 5.15879 3.13357 4.79879C3.30457 4.43879 3.60157 4.16879 3.97957 4.04279C5.68057 3.44879 9.32557 3.30479 11.7466 4.87979C15.5896 7.38179 17.6956 4.81679 17.7856 4.70879C17.9476 4.51079 18.2086 4.42979 18.4516 4.51979C18.6946 4.60079 18.8566 4.83479 18.8566 5.08679C18.8566 5.23079 18.8296 8.70479 16.5886 10.5948C15.3646 11.6208 13.7536 11.9718 11.7916 11.6388C9.64957 11.2788 7.63357 12.1968 6.80557 12.6558L8.99257 18.5058C9.10957 18.8208 8.94757 19.1628 8.64157 19.2798C8.57857 19.2978 8.50657 19.3068 8.43457 19.3068ZM6.84157 4.82579C5.86957 4.82579 4.97857 4.96079 4.37557 5.16779C4.28557 5.20379 4.24057 5.26679 4.22257 5.30279C4.20457 5.33879 4.17757 5.41979 4.21357 5.51879L6.39157 11.5038C7.43557 10.9548 9.62257 10.0368 12.0076 10.4418C13.6096 10.7118 14.8966 10.4508 15.8326 9.65879C16.8586 8.79479 17.3176 7.44479 17.5156 6.43679C16.2466 7.18379 14.0416 7.77779 11.1076 5.86979C9.91957 5.12279 8.29057 4.82579 6.84157 4.82579Z"
                fill={iconColor}
                stroke={iconColor}
                strokeWidth="0.4"
            />
        </svg>
    );
}